import React from 'react';
import { Box, Skeleton } from '@mui/material';
import StyledBox from 'views/rebranded-module/information-module/AboutUsViewV2/components/ExperienceSection/ExperienceSection.styles';

const ExperienceSectionSkeleton: React.FC = () => {
  return (
    <StyledBox>
      <Box className="ESOverlay" />
      <Box className="ESContent">
        <Skeleton variant="text" width="80%" height={48} sx={{ mb: 3, mx: 'auto' }} />
        <Skeleton variant="text" width="90%" height={24} sx={{ mb: 2, mx: 'auto' }} />
        <Skeleton variant="text" width="95%" height={24} sx={{ mb: 2, mx: 'auto' }} />
        <Skeleton variant="text" width="88%" height={24} sx={{ mb: 3, mx: 'auto' }} />
        <Skeleton variant="text" width="92%" height={24} sx={{ mb: 2, mx: 'auto' }} />
        <Skeleton variant="text" width="85%" height={24} sx={{ mx: 'auto' }} />
      </Box>
    </StyledBox>
  );
};

export { ExperienceSectionSkeleton };
